// FlixPlayerActionButton.js
import { connect } from 'react-redux';
import { replace } from 'redux-first-history';
import withRouter from '../component/WithRouter.jsx';

import { PREVIEW_PRESET } from '../RemoteConfigKeys.js';

import FlixPlayerActionButton from '../component/FlixPlayerActionButton.jsx';

import login from '../action/login.js';
import sendUnlockMessage from '../action/sendUnlockMessage.js';
import addModal from '../action/addModal.js';

import getMessageData from '../selector/getMessageData.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMessageUnlockPrice from '../selector/getMessageUnlockPrice.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const mapStateToProps = (state, { messageId }) => {
  const unlockPrice = getMessageUnlockPrice(state, messageId);
  const meId = getMeData(state, 'id');

  return {
    isAuthed: !!getMeData(state, 'id'),
    unlockPrice,
    canViewMedia: getMessageData(state, messageId, 'canViewMedia'),
    isUnlocking: getNetworkingData(
      state,
      ['messages', messageId, 'unlock'],
      'isFetching'
    ),
    isPresenceUserChannelSubscribed: getOperationData(
      state,
      ['pusher', 'channels', `presence-enc-user@${meId}`],
      'subscribed'
    ),
    isDrmLicenseAvailabilityFetched: getNetworkingData(
      state,
      ['drm', 'licenseAvailability', messageId],
      'isFetched'
    ),
    isAgeVerified: getRemoteConfigData(state, PREVIEW_PRESET) === 'clear',
    badges: getMessageData(state, messageId, 'badges'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: () => dispatch(login()),
    addModal: data => dispatch(addModal(data)),
    sendUnlockMessage: data => dispatch(sendUnlockMessage(data)),
    replace: data => dispatch(replace(data)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlixPlayerActionButton)
);
